// extracted by mini-css-extract-plugin
export default {"plan":"styles_plan__TBgQs","characteristics":"styles_characteristics__6Zmxm","benefits":"styles_benefits__gM6z+","plan-status":"styles_plan-status__v1Ck1"};